import { computed, inject, Provider } from '@angular/core';
import { CURRENT_USER_ROLE } from '@dss-libs/shared/utility/global-injection-tokens';
import { UserManagementService } from '../services/user-management/user-management.service';

/** Binds CURRENT_USER_ROLE to the signed-in user's role. Apps that render AuthorizedRoleDirective must provide it. */
export function provideCurrentUserRole(): Provider {
  return {
    provide: CURRENT_USER_ROLE,
    useFactory: () => {
      const users = inject(UserManagementService);
      return computed(() => users.userProfile()?.role);
    },
  };
}
